<template>
  <ValidationProvider :rules="rules" v-slot="{ errors }" mode="passive">
    <div>
      <label class="body-small" v-if="label">{{ label }}</label>
      <vuetify-google-autocomplete
        v-model="input"
        :dense="dense"
        ref="input"
        id="map"
        :class="label ? 'mt-1' : ''"
        v-bind="$attrs"
        :value="input"
        country="us"
        @keydown.enter.prevent="onEnterPress"
        outlined
        :error-messages="errors"
        v-on:placechanged="$emit('onAddress', $event)"
        @input="$emit('input', input)"
      >
        <template v-slot:append>
          <v-tooltip bottom v-if="help">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="" x-small>
                <v-icon>mdi-help-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ help }}</span>
          </v-tooltip>
        </template>
      </vuetify-google-autocomplete>
    </div>
  </ValidationProvider>
</template>

<script>
import {getRules, inputDense} from "../../../assets/utils/common.utils.js";

export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    help: {
      type: String,
      default: "",
    },
    dense: {
      type: Boolean,
      default: inputDense,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: "",
    },
    customRules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      input: "",
    };
  },
  computed: {
    getRules() {
      let { customRules, rules } = this;
      if (customRules.length > 0) return customRules;
      return getRules(rules);
    },
  },
  watch: {
    value(val) {
      this.input = val;
    },
  },
  methods: {
    onEnterPress() {
      console.log("enter");
    },
  },
  mounted() {
    this.input = this.value;
    let map = document.getElementById("map");
    if (map) {
      map.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      });
    }
  },
};
</script>
